// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const ArrowRight: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="m21.696 11.304-6-6a.984.984 0 0 0-1.391 1.392l4.29 4.291H3.002a1.013 1.013 0 1 0 0 2.026h15.595l-4.291 4.291a.984.984 0 1 0 1.391 1.392l6-6a.98.98 0 0 0 0-1.392Z" />
  </SvgIcon>
);

ArrowRight.activeColor = 'inherit';
ArrowRight.muiName = 'ArrowRight';
